import React from "react";
import classNames from "classnames";
import styles from "./checkboxWithText.module.css";

type CheckboxWithTextProps = React.InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  testId?: string;
  children: React.ReactElement | string;
};

export const CheckboxWithText = ({
  id,
  testId = "consent",
  children,
  ...rest
}: CheckboxWithTextProps) => {
  return (
    <label
      htmlFor={id}
      className={classNames(styles.checkbox, "flex pb-xs text-left text-xs")}
    >
      <input
        id={id}
        data-testid={testId}
        type="checkbox"
        autoComplete="off"
        {...rest}
      />
      <span className="mr-md"></span>
      <div className="flex items-center">
        <span className="text-3xs leading-tight tracking-tight">
          {children}
        </span>
      </div>
    </label>
  );
};
